export default "__VITE_ASSET__Dd4w2u0C__"